import { jsx as l } from "react/jsx-runtime";
import "react";
var o = (e) => /* @__PURE__ */ l("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 36 36",
  ...e,
  children: /* @__PURE__ */ l("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.2 32h5.6c5.28 0 7.92 0 9.56-1.64C32 28.72 32 26.08 32 20.8v-.612c0-1.222 0-2.14-.06-2.888h-5.673c-1.536 0-2.893 0-3.987-.147-1.186-.16-2.372-.525-3.34-1.493-.968-.968-1.334-2.154-1.493-3.34-.147-1.094-.147-2.45-.147-3.987l.013-3.968c0-.116.01-.23.029-.342C16.77 4 16.09 4 15.242 4 9.934 4 7.28 4 5.64 5.64 4 7.28 4 9.92 4 15.2v5.6c0 5.28 0 7.92 1.64 9.56C7.28 32 9.92 32 15.2 32Zm7.55-25.125 5.542 4.988c1.704 1.533 2.612 2.351 3.12 3.337H26.4c-3.3 0-4.95 0-5.975-1.025C19.4 13.15 19.4 11.5 19.4 8.2l.013-3.828c.969.372 1.758 1.082 3.337 2.503Z",
    clipRule: "evenodd"
  })
});
export {
  o as default
};
